var _path, _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 46.5c12.426 0 22.5-10.074 22.5-22.5s-10.074-22.5-22.5-22.5-22.5 10.074-22.5 22.5 10.074 22.5 22.5 22.5zm0 1.5c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    clipRule: "evenodd",
    fill: "url(#paint0_linear_1908_20857)",
    fillRule: "evenodd",
    filter: "url(#filter185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_20857",
    x2: 48,
    y1: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01EEFD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#073DC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter185",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color1",
    type: "hueRotate",
    values: 180
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 -0.21 -0.72 -0.07 2 0 "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter381",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color1",
    type: "hueRotate",
    values: 180
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphic",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 -0.21 -0.72 -0.07 2 0 "
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "color1",
    type: "hueRotate",
    values: 180
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "color2",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 -0.21 -0.72 -0.07 2 0 "
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.91867 0 0 .91867 -.46099 9.0123)",
    x: 6.7118645,
    y: 21.355932,
    fill: "#ffffff",
    filter: "url(#filter381)",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.7118645,
    y: 21.355932,
    fontFamily: "Verdana"
  }, "TEST"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTest);
export default __webpack_public_path__ + "static/media/logo-test.61e07c16cb0215c0a1f370f156cf9b43.svg";
export { ForwardRef as ReactComponent };